import HorizontalSpacer from './HorizontalSpacer';

export default HorizontalSpacer;
